import * as React from "react";
import "../assets/LegalPage.scss";
import { LegalPage } from "./LegalPage";
import { regionHelper } from "src/features/region";

interface Props {
    goBack?: () => void;
}

const getTermsUrl = (): string => {
    if (regionHelper.isAU) return "legal/terms-of-use---australia-new-zealand";
    if (regionHelper.isUK) return "legal/terms-of-use-uk";
    return `legal/app-meandu-terms-conditions-${regionHelper.region.id}`;
};

export const TermsOfUse = ({ goBack }: Props) => {
    return <LegalPage title="Terms of Use" goBack={goBack} relativeUrl={getTermsUrl()} />;
};
